import React, { CSSProperties } from 'react';
import { InputContainer } from './styles';

interface CpfInput {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  style: CSSProperties;
}

export const CpfInput = React.forwardRef<HTMLElement, CpfInput>(props => {
  const { onChange, style, ...other } = props;
  return (
    <InputContainer
      {...other}
      mask="000.000.000-00"
      definitions={{
        '#': /[1-11]/,
      }}
      onAccept={(value: any) =>
        onChange({ target: { name: props.name, value } })
      }
      sx={{
        width: '100%',
        display: 'flex',
        ...style,
      }}
      overwrite
    />
  );
});
